import type { SearchPayload } from '@civilgrid/ui/hooks';
import { getAxiosClient } from './common';

const axios = getAxiosClient();

export type DataRefreshStatusRow = {
  id: string;
  /** Jurisdiction / agency display name. */
  name: string;
  /** Conflict dataset type: Paving Projects | Moratoriums | CIP. */
  type: string;
  /** ISO date of the last data refresh; null when never refreshed. */
  lastRefresh: string | null;
  researchStatus: string;
  projectsImpacted: number;
  /** Refresh-cycle notes maintained by the CivilGrid team (agencies.refreshNotes). */
  notes: string | null;
};

export type DataRefreshStatusApiResponse = {
  items: DataRefreshStatusRow[];
  count: number;
};

/**
 * Fetch per-jurisdiction refresh status for the organization.
 * Uses GET /v1/dataRefreshStatus; backend honors pagination, sort, filters, and globalFilter
 * (same SearchPayload contract as /v3/projects).
 */
export async function fetchDataRefreshStatus(
  organizationId: string,
  searchPayload: SearchPayload,
  { signal }: { signal?: AbortSignal } = {},
): Promise<DataRefreshStatusApiResponse> {
  const params = new URLSearchParams({
    organizationId,
    search: JSON.stringify(searchPayload),
  });

  const { data } = await axios({
    method: 'GET',
    url: `/v1/dataRefreshStatus?${params.toString()}`,
    signal,
  });

  const items = (data.items ?? []) as DataRefreshStatusRow[];
  const count = typeof data.count === 'number' ? data.count : items.length;
  return { items, count };
}
